<template>
    <div>
        <v-container justify-start>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">
                        Edit Player
                    </div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style="" to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style="" to="/admin/players" v-bind:exact="exact">Players</v-breadcrumbs-item>
                        <v-breadcrumbs-item style disabled>Edit Player</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>
        <v-container grid-list-md>
            <v-layout row wrap justify-start>
                <v-flex xs12 sm6>
                    <v-card>
                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-text-field
                                    name="first_name"
                                    label="First Name"
                                    v-model="first_name"
                                    v-bind:rules="firstNameRules"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    name="last_name"
                                    label="Last Name"
                                    v-model="last_name"
                                    v-bind:rules="lastNameRules"
                                    required
                                ></v-text-field>
                                <v-text-field
                                    name="email"
                                    label="Email"
                                    v-model="email"
                                ></v-text-field>
                                <v-text-field
                                    name="phone"
                                    label="Phone"
                                    v-model="phone"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                flat
                                color="primary"
                                v-bind:disabled="!valid"
                                v-on:keyup.enter="submit"
                                v-on:click="submit"
                                data-cy="signinSubmitBtn"
                            >Update Player</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

export default {
    name: 'AdminPlayersEdit',
    props: ['id'],
    data() {
        return {
            exact: true,
            valid: false,
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            firstNameRules: [
                (v) => !!v || 'First name is required',
                (v) => v.length >= 1 || 'First must be greater than one characters',
            ],
            lastNameRules: [
                (v) => !!v || 'Last name is required',
                (v) => v.length >= 1 || 'Last must be greater than one characters',
            ]
        }
    },
    mounted() {
        let player = this.$store.getters.getPlayerById(this.id)
        this.first_name = player.first_name
        this.last_name = player.last_name
        this.email = player.email
        this.phone = player.phone
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('updatePlayer', {
                    id: this.id,
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    phone: this.phone
                })
            }
        }
    }
}
</script>

<style scoped></style>
